export default __webpack_public_path__ + "static/media/wibs with for light mode.de7c6753.svg";